<template>
  <div class="medication-request-patient-info">
    <div class = "row">
      <div class ="col-md-4">
        <form-group
          :errors="errors"
          :required="true"
          error-key="subject.id"
          for-id="patient-id"
          label="Número de Documento">

          <app-rut-input
          id="patient-id"
          type="text"
          class="form-control"
          :value="subject.id"
          :foreig="true"
          @input="handlePatientUpdate('id', $event)"
          @blur="handlePatientIdInputBlur" />
        </form-group>
      </div>
      <div class ="col-md-4">
         <form-group
          :errors="errors"
          :required="true"
          error-key="subject.document_type"
          for-id="document-type"
          label="Tipo de Documento">
          <select
          id="document-type"
          type="text"
          class="form-control"
          :value="subject.document_type"
          @input="handlePatientCountry('document_type', $event)">
            <option value="">Seleccione</option>
            <option value="PPN">Pasaporte</option>
            <option :value="DNIValue">DNI</option>
          </select>
        </form-group>
      </div>

      <div class = "col-md-4">
         <form-group
          :errors="errors"
          :required="true"
          error-key="subject.country"
          for-id="country"
          label="País de Emisión">

          <el-select
            v-model="subject.country"
            clearable
            filterable
            @input="handlePatientCountry('country', $event)">
            <el-option value="" label="Seleccione"></el-option>

            <el-option
              v-for="country in countries"
              :key="country['ISO3166-1-numeric']"
              :value="country['ISO3166-1-numeric']"
              :label="country['official_name_es']" />
          </el-select>
        </form-group>
      </div>

    </div>


    <form-group
      v-loading="fetchingSubjectInformation"
      :errors="errors"
      error-key="subject.name.given"
      for-id="patient-given-name"
      label="Nombre">
      <input
        id="patient-given-name"
        type="text"
        class="form-control"
        :value="subject.name.given"
        @keyup="handlePatientInputs('name.given', $event)">
    </form-group>
    <form-group
      v-loading="fetchingSubjectInformation"
      for-id="patient-family-name"
      :errors="errors"
      error-key="subject.name.family"
      label="Apellidos">
      <input
        id="patient-family-name"
        type="text"
        class="form-control"
        :value="subject.name.family"
        @keyup="handlePatientInputs('name.family', $event)">
    </form-group>

    <div class = "row">
      <div class = "col-md-6">
        <form-group
          :errors="errors"
          :required="true"
          error-key="subject.birthDate"
          for-id="birth_date"
          label="Fecha de Nacimiento">
          <el-date-picker
            v-model="subject.birthDate"
            type="date"
            placeholder="Selecciona un día"
            value-format="yyyy-MM-dd"
            format="dd-MM-yyyy"
            :picker-options="fechaNacimientoPickerOptions"
            @change="handlePatientUpdate('birthDate', $event)">
          </el-date-picker>
        </form-group>
      </div>
      <div class = "col-md-6">
        <form-group
          :errors="errors"
          :required="true"
          error-key="subject.gender"
          for-id="gender"
          label="Genero">
          <select
          id="gender"
          type="text"
          class="form-control"
          :value="subject.gender"
          @input="handlePatientUpdate('gender', $event)">
            <option value="">Seleccione</option>
            <option value="male">Masculino</option>
            <option value="female">Femenino</option>
          </select>
        </form-group>
      </div>
    </div>

    <address-input
      :value="subject.address"
      :errors="errors"
      errors-prefix="subject"
      @input="handlePatientUpdate('address', $event)" />

    <form-group
      :errors="errors"
      :required="false"
      error-key="subject.email"
      for-id="patient-email"
      label="Email">
      <input
        id="patient-email"
        type="text"
        class="form-control"
        :value="subject.email"
        @input="cleanEmail" />
    </form-group>

    <el-dialog
      title="Error"
      width="60%"
      :before-close="handleCloseRutError"
      custom-class="medication-request-form__dialog"
      :visible="rutError != ''">

      <div class ="responsive-padding-css" style="word-break: keep-all;">


      {{rutError}}
      </div>

    </el-dialog>

  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import AppRutInput from '@/components/AppRutInput';
import rutHelper from '@/helpers/rut';
import _get from 'lodash/get';
import AddressInput from '@/components/medication/AddressInput';
import dayjs from 'dayjs';
import countries from '@/helpers/IsoCountries';

const requiresLegalRepresentative = function(date) {
  if (!date) return false;
  return dayjs(date, 'YYYY-MM-DD') > dayjs().subtract(18, 'year');
};

export default {
  name: 'MedicationRequestPatientInfo',
  components: {
    AddressInput,
    FormGroup,
    AppRutInput
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      fetchingSubjectInformation: false,
      fetchingContactSubjectInformation: false,
      lastSearch: null,
      lastContactSearch: null,
      rutError : '',
      rutErrorContact : false,
      subject: JSON.parse(JSON.stringify(this.value)),
      countries: countries,
      fechaNacimientoPickerOptions : {
        disabledDate : this.disabledFechaNacimientoDate
      }
    };
  },
  computed: {
    requiresLegalRepresentative() {
      return requiresLegalRepresentative(this.subject.birthDate);
    },
    DNIValue(){

      if (!this.subject.country || this.subject.country == ''){
        return 'NN';
      };

      let code = '';
      countries.forEach(country => {

        if (country['ISO3166-1-numeric'] == this.subject.country){
          code = country['ISO3166-1-Alpha-3'];
        }

      });

      const finalCode = 'NN' + code;
      if (this.subject.document_type != 'PPN'){
        this.handlePatientUpdate('document_type', finalCode);
      }

      return finalCode;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.subject)) {
          this.subject = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },
  methods: {
    disabledFechaNacimientoDate(date){
      return (date > new Date());
    },
    cleanEmail(){
      document.getElementById('patient-email').value = document.getElementById('patient-email').value.replace(/[^a-zA-Z0-9@._-]/g, "");
      this.$emit('input', 'email', document.getElementById('patient-email').value);
    },
    handlePatientUpdate(field, event) {

      const value = _get(event, 'target.value', event);
      this.$emit('input', field, value);
    },
    clearUser() {
      this.handlePatientUpdate('name.given', '');
      this.handlePatientUpdate('name.family', '');
      this.handlePatientUpdate('birthDate', null);
      this.clearUserContact();
    },
    clearUserContact() {
      this.handlePatientUpdate('contact[0]', { id: '', birthDate: null, relationship: [], name: { family: '', given: '' } });
    },
    handleContactIdInputBlur() {

      if (!rutHelper.validate(this.subject.contact[0].id)) {
        this.rutErrorContact = true;
        this.rutError = 'El Run Ingresado es inválido';
        this.clearUserContact();
        return;
      }

     // if (this.subject.contact[0].id === this.lastContactSearch) return;
      this.lastContactSearch = this.subject.contact[0].id;

      this.fetchingContactSubjectInformation = true;
      this.$store.dispatch('fetchSubjectInformation', this.subject.contact[0].id)
        .then(subjectInformation => {
          const birthDate = _get(subjectInformation, 'birthDate');
          if (requiresLegalRepresentative(birthDate)) {
            this.$message({
              message: 'El representante legal debe ser mayor de 18 años.',
              type: 'error'
            });
            return;
          }
          const givenName = _get(subjectInformation, 'name[0].given.0', '').trim();
          const familyName = _get(subjectInformation, 'name[0].given.1', '').trim() + ' ' + _get(subjectInformation, 'name[0].given.2', '').trim();
          this.handlePatientUpdate('contact[0].relationship', [{ 'system': 'http://hl7.org/fhir/ValueSet/patient-contactrelationship', 'code': 'N', 'display': 'Next-of-Kin' }]);
          this.handlePatientUpdate('contact[0].display', `${givenName} ${familyName}`);
          this.handlePatientUpdate('contact[0].reference', subjectInformation.reference);
          this.handlePatientUpdate('contact[0].name.given', givenName);
          this.handlePatientUpdate('contact[0].name.family', familyName);
          this.handlePatientUpdate('contact[0].birthDate', birthDate);
        })
        .catch(e => {
          this.rutErrorContact = true;
          this.rutError = _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del representante legal del paciente.');
          /*
          this.$message({
            message: _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del representante legal del paciente.'),
            type: 'error'
          });
          */
          this.clearUserContact();
        })
        .finally(() => {
          this.fetchingContactSubjectInformation = false;
        });
    },
    handlePatientCountry(keyinput, event){
      console.log('document_type es:', this.subject.document_type);
      this.handlePatientUpdate(keyinput, event);

      this.$nextTick(() => {
        console.log('document_type es:', this.subject.document_type);
        this.handlePatientIdInputBlur();
      });
    },
    handlePatientIdInputBlur() {

      if (this.subject.id.trim() == '' || !this.subject.country || this.subject.country == '' || !this.subject.document_type || this.subject.document_type == ''){
        return;
      }

      this.lastSearch = this.subject.id;
      this.fetchingSubjectInformation = true;

      this.$store.dispatch('fetchSubjectInformationForeigs', { subjectId : this.subject.id, type : this.subject.document_type, country : this.subject.country })
        .then(subjectInformation => {
          if (typeof(subjectInformation.deceasedDate) != 'undefined'){
            const isDeceased = subjectInformation.deceasedDate !== '';
            if (isDeceased) throw new Error(100);
          }


          const givenNameObj = _get(subjectInformation, 'name[0].given', []);
          const givenName = givenNameObj.join(' ').trim();

         // const givenName = _get(subjectInformation, 'name[0].given.0', '').trim();
          let familyName = _get(subjectInformation, 'name[0].family', '').trim();

          const secondFamily = _get(subjectInformation, 'name[0]._family.extension[0].stringValue', '').trim();

          if (secondFamily != ''){
            familyName = familyName + ' ' + secondFamily;
          }

          let birthDate = _get(subjectInformation, 'birthDate');
          let gender = _get(subjectInformation, 'gender');
          let api_id = _get(subjectInformation, 'id');

          this.handlePatientUpdate('display', `${givenName} ${familyName}`);
          this.handlePatientUpdate('reference', subjectInformation.reference);
          this.handlePatientUpdate('name.given', givenName);
          this.handlePatientUpdate('name.family', familyName);
          this.handlePatientUpdate('gender', gender);
          this.handlePatientUpdate('api_id', api_id);
          if (subjectInformation.address) {
            try {
              this.handlePatientUpdate('address',  { text: subjectInformation.address[0].line, state: subjectInformation.address[0].state, district: subjectInformation.address[0].district });
            } catch(e){
              //Si cae acá, tiene el modo de almacenamiento viejo para la dirección.
              this.handlePatientUpdate('address', subjectInformation.address);
            }
          } else {
            this.handlePatientUpdate('address', { text: '', state: '', district: '' });
          }

          if (subjectInformation.email){
            this.handlePatientUpdate('email', subjectInformation.email);
          } else {
            this.handlePatientUpdate('email', '');
          }

          if (subjectInformation.legal_representative){
            this.$nextTick(() => {
              this.handlePatientUpdate('contact[0].id', subjectInformation.legal_representative.claveunica_id);
              this.$nextTick(() => {
                this.handleContactIdInputBlur();
              });
            });
          }

          birthDate = typeof(birthDate) == 'undefined' ? '' : birthDate;
          this.handlePatientUpdate('birthDate', birthDate);
          if (requiresLegalRepresentative(birthDate)) {
            this.handlePatientUpdate('contact[0]', { id: '', birthDate: null, name: { family: '', given: '' } });
          } else {
            this.clearUserContact();
          }
        })
        .catch(e => {
          if (e.message === '100') {
            this.rutErrorContact = true;
            this.rutError = _get(
              e,
              'response.data.message',
              'No está permitido prescribir a personas fallecidas.'
            );
          } else {
            this.rutErrorContact = false;
            //   this.rutError = _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del representante legal del paciente.');
            console.log('el error es:', e);
            /*
            this.$message({
              message: _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del paciente.'),
              type: 'error'
            });
            */
          };

          this.clearUser();
        })
        .finally(() => {
          this.fetchingSubjectInformation = false;
        });
    },
    handlePatientInputs(keyinput, event){

      this.handlePatientUpdate(keyinput, event);

      const givenName = document.getElementById('patient-given-name').value;
      const familyName = document.getElementById('patient-family-name').value;

      this.handlePatientUpdate('display', `${givenName} ${familyName}`);


    },
    handleCloseRutError(){
      this.rutError = '';
      if (this.rutErrorContact){
        this.subject.contact[0].id = ''
      }else{
        this.subject.id = '';
      }
    }
  }
};
</script>
